export const SERVICE_FEE = 19;
